///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format } from "date-fns";

import { dateFormat, division } from "./types";

export const formatDateAndTime = (value, userDivision) =>
  value &&
  format(
    new Date(value),
    userDivision === division.coy
      ? dateFormat.MMddyyyyhmma
      : dateFormat.ddMMyyyyhmma
  );
